import { makeAutoObservable, toJS } from 'mobx';
import { createDecisionFeedbackTable } from '../../utils/helpers';

let status = {};
status.LOGIN = 0;
status.LOGOUT = 0;
status.SUBJECT_OPEN = 0;
status.SUBJECT_CLOSE = 0;
status.ANSWARE_CORRECT = 0;
status.ANSWARE_INCORRECT = 0;
status.VIDEO_START = 0;
status.VIDEO_25 = 0;
status.VIDEO_50 = 0;
status.VIDEO_75 = 0;
status.VIDEO_95 = 0;
status.VIDEO_100 = 0;

class SubjectStore {
    numberOfDecisions = 0;
    description = null;
    duration = 0;
    id = null;
    language = null;
    sendData = null;
    sent = null;
    slug = null;
    status = status;
    subject_id = null;
    thumb = null;
    title = null;
    type = null;
    notes = [];
    trainings = [];
    video_decisions = [];
    video_id_jw = null;
    completed = false;
    started = false;
    decisionFeedbackTable = [];
    stored_decisions = [];
    decision_longestPossiblePath = 0;
    hasBeenTried = false;
    answerSubjectId = null;
    answerSubjectLength = 0;
    correctPath = [];

    constructor(subject) {
        if (!subject) return null;
        makeAutoObservable(this);
        this.numberOfDecisions = subject.numberOfDecisions;
        this.description = subject.description;
        this.duration = subject.duration;
        this.id = subject.id;
        this.notes = subject.notes;
        this.trainings = subject.trainings;
        this.language = subject.language;
        this.sendData = subject.sendData;
        this.sent = subject.sent;
        this.slug = subject.slug;
        this.status = subject.status;
        this.subject_id = subject.subject_id;
        this.thumb = subject.thumb;
        this.title = subject.title;
        this.type = subject.type;
        if (subject.video_decisions) {
            this.video_decisions = subject.video_decisions.decisions;
            this.answerSubjectId = subject.video_decisions.answerSubjectId;
            this.answerSubjectLength = subject.video_decisions.answerSubjectLength;
            this.correctPath = subject.video_decisions.correctPath;
        }

        this.video_id_jw = subject.video_id_jw;

        this.finishedState = null;
    }

    isSubjectDone() {
        return !!this.status.ANSWARE_CORRECT;
    }

    resetDecisions() {
        this.stored_decisions = [];
        this.decision_longestPossiblePath = this.numberOfDecisions;
    }

    hasSeenAnswer() {
        this.stored_decisions = this.correctPath;
        this.decision_longestPossiblePath = this.stored_decisions.length;

        createDecisionFeedbackTable(
            this.video_decisions,
            toJS(this.correctPath),
            [],
            0
        );
    }

    setPreviewFinishedState(state) {
        this.finishedState = state;
        this.hasBeenTried = true;
    }

    setLogDecision(decision) {
        this.stored_decisions.push(decision);
        this.updateLongestDecisionPath(decision);
        if (!this.existsNextDecision(decision)) {
            this.createDecisionFeedbackTable();
        }
    }

    updateLongestDecisionPath(decision) {
        if (!this.video_decisions[decision.next].decision_1)
            this.decision_longestPossiblePath = this.stored_decisions.length;
        else this.decision_longestPossiblePath = this.numberOfDecisions;
    }

    existsNextDecision(decision) {
        if (!this.video_decisions[decision.next].questionText) {
            this.hasBeenTried = true;
        }
        return !!this.video_decisions[decision.next].questionText;
    }

    createDecisionFeedbackTable() {
        createDecisionFeedbackTable(
            this.video_decisions,
            toJS(this.stored_decisions),
            [],
            0
        );
    }

    get storedDecisions() {
        return this.stored_decisions;
    }

    get numberOfRightAnswers() {
        return (
            (this.stored_decisions &&
                !this.stored_decisions.previewed &&
                this.stored_decisions.reduce((n, x) => n + x.result, 0)) ||
            0
        );
    }

    get numberOfPossibleDecisions() {
        return this.hasBeenTried
            ? this.decision_longestPossiblePath
            : this.numberOfDecisions;
    }
}

export default SubjectStore;
